var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "custom-box",
        {
          attrs: {
            title: "添加文档",
            visible: _vm.dialog,
            modal: false,
            "close-on-click-modal": false,
            "modal-append-to-body": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialog = $event
            },
            close: function($event) {
              return _vm.resetForm("ruleForm")
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "popover",
              attrs: {
                "label-position": "left",
                rules: _vm.rules,
                model: _vm.paramsData,
                "label-width": "110px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "version", label: "版本" }
                },
                [
                  _c("el-input", {
                    staticClass: "operationFrame-entity",
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.paramsData.version,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "version", $$v)
                      },
                      expression: "paramsData.version"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "title", label: "标题" }
                },
                [
                  _c("el-input", {
                    staticClass: "operationFrame-entity",
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.paramsData.title,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "title", $$v)
                      },
                      expression: "paramsData.title"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "type", label: "上传类型" }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "请选择"
                      },
                      on: { change: _vm.handleTypeChange },
                      model: {
                        value: _vm.paramsData.type,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "type", $$v)
                        },
                        expression: "paramsData.type"
                      }
                    },
                    [
                      _c("el-option", {
                        key: "1",
                        attrs: { label: "文本", value: "text" }
                      }),
                      _c("el-option", {
                        key: "2",
                        attrs: { label: "上传", value: "upload" }
                      }),
                      _c("el-option", {
                        key: "3",
                        attrs: { label: "外部URL", value: "url" }
                      }),
                      _c("el-option", {
                        key: "4",
                        attrs: { label: "图片", value: "image" }
                      }),
                      _c("el-option", {
                        key: "5",
                        attrs: { label: "视频", value: "vedio" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              ["image", "vedio"].includes(_vm.paramsData.type)
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "lodingItem",
                      attrs: { prop: "text_content", label: "描述" }
                    },
                    [
                      _c("el-input", {
                        staticClass: "operationFrame-entity",
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.paramsData.text_content,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "text_content", $$v)
                          },
                          expression: "paramsData.text_content"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              ["image", "vedio"].includes(_vm.paramsData.type)
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "lodingItem",
                      attrs: { prop: "UploadType", label: "上传方式" }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            clearable: "",
                            filterable: "",
                            placeholder: "请选择"
                          },
                          model: {
                            value: _vm.paramsData.UploadType,
                            callback: function($$v) {
                              _vm.$set(_vm.paramsData, "UploadType", $$v)
                            },
                            expression: "paramsData.UploadType"
                          }
                        },
                        [
                          _c("el-option", {
                            key: "1",
                            attrs: {
                              label: "外部资源引用",
                              value: "ExternalResources"
                            }
                          }),
                          _c("el-option", {
                            key: "2",
                            attrs: { label: "直接上传", value: "DirectUpload" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.paramsData.UploadType == "ExternalResources"
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "lodingItem",
                      attrs: { prop: "source_uri", label: "外部资源链接" }
                    },
                    [
                      _c("el-input", {
                        staticClass: "operationFrame-entity",
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.paramsData.source_uri,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "source_uri", $$v)
                          },
                          expression: "paramsData.source_uri"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.paramsData.type == "text"
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "lodingItem",
                      attrs: { prop: "text_content", label: "文本内容" }
                    },
                    [
                      _c("el-input", {
                        staticClass: "operationFrame-entity",
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.paramsData.text_content,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "text_content", $$v)
                          },
                          expression: "paramsData.text_content"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.paramsData.type == "url"
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "lodingItem",
                      attrs: { prop: "url", label: "外部URL" }
                    },
                    [
                      _c("el-input", {
                        staticClass: "operationFrame-entity",
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.paramsData.url,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "url", $$v)
                          },
                          expression: "paramsData.url"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.paramsData.type === "upload" ||
              (["image", "vedio"].includes(_vm.paramsData.type) &&
                _vm.paramsData.UploadType === "DirectUpload")
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "lodingItem",
                      staticStyle: { width: "100%" },
                      attrs: { prop: "file", label: _vm.uploadLabel }
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "upload-demo",
                          attrs: {
                            action: "#",
                            "auto-upload": false,
                            "on-change": _vm.handleFileChange,
                            "on-remove": _vm.handleFileRemove,
                            "file-list": _vm.fileList,
                            limit: 1,
                            "on-exceed": _vm.handleExceed,
                            accept: _vm.acceptTypes
                          }
                        },
                        [
                          _c(
                            "el-button",
                            { attrs: { size: "small", type: "primary" } },
                            [_vm._v("点击上传")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "el-upload__tip",
                              attrs: { slot: "tip" },
                              slot: "tip"
                            },
                            [_vm._v(" " + _vm._s(_vm.uploadTipText) + " ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.rawData.game_mark.indexOf("yjfm") == -1
                ? [
                    _c(
                      "el-form-item",
                      { staticClass: "lodingItem", attrs: { label: "" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "flex-1",
                            attrs: { filterable: "", placeholder: "请选择" },
                            on: { change: _vm.getServer },
                            model: {
                              value: _vm.paramsData.is_prod,
                              callback: function($$v) {
                                _vm.$set(_vm.paramsData, "is_prod", $$v)
                              },
                              expression: "paramsData.is_prod"
                            }
                          },
                          _vm._l(_vm.severlist, function(item) {
                            return _c("el-option", {
                              key: item.label,
                              attrs: { label: item.label, value: item.value }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "lodingItem",
                        attrs: { label: "服务器", prop: "server_id" }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "flex-1",
                            attrs: {
                              multiple: "",
                              "collapse-tags": "",
                              clearable: "",
                              filterable: "",
                              placeholder: "请选择服务器"
                            },
                            on: { change: _vm.YjfmSeverChange },
                            model: {
                              value: _vm.paramsData.server_id,
                              callback: function($$v) {
                                _vm.$set(_vm.paramsData, "server_id", $$v)
                              },
                              expression: "paramsData.server_id"
                            }
                          },
                          [
                            _c(
                              "el-checkbox",
                              {
                                on: { change: _vm.selectYjfmAll },
                                model: {
                                  value: _vm.checked,
                                  callback: function($$v) {
                                    _vm.checked = $$v
                                  },
                                  expression: "checked"
                                }
                              },
                              [_vm._v("全选")]
                            ),
                            _vm._l(_vm.serverList, function(item) {
                              return _c("el-option", {
                                key: item.serverID,
                                attrs: {
                                  label: item.serverName,
                                  value: item.serverID
                                }
                              })
                            })
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ]
                : [
                    _c(
                      "el-form-item",
                      { staticClass: "lodingItem", attrs: { label: "" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "flex-1",
                            attrs: { filterable: "", placeholder: "请选择" },
                            on: { change: _vm.envIdChange },
                            model: {
                              value: _vm.paramsData.env_id,
                              callback: function($$v) {
                                _vm.$set(_vm.paramsData, "env_id", $$v)
                              },
                              expression: "paramsData.env_id"
                            }
                          },
                          _vm._l(_vm.szgmEnv, function(item) {
                            return _c("el-option", {
                              key: item.label,
                              attrs: { label: item.label, value: item.id }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { staticClass: "lodingItem", attrs: { label: "" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              filterable: "",
                              placeholder: "服务器渠道"
                            },
                            on: { change: _vm.serverChange },
                            model: {
                              value: _vm.server_channel,
                              callback: function($$v) {
                                _vm.server_channel = $$v
                              },
                              expression: "server_channel"
                            }
                          },
                          _vm._l(_vm.serverChannel, function(item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { staticClass: "lodingItem", attrs: { label: "" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              clearable: "",
                              filterable: "",
                              placeholder: "是否展示测试服"
                            },
                            on: { change: _vm.serverChannelChange },
                            model: {
                              value: _vm.show_test,
                              callback: function($$v) {
                                _vm.show_test = $$v
                              },
                              expression: "show_test"
                            }
                          },
                          _vm._l(_vm.serverType, function(item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "lodingItem",
                        attrs: { label: "服务器", prop: "server_id" }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              multiple: "",
                              "collapse-tags": "",
                              filterable: "",
                              placeholder: "服务器"
                            },
                            on: { change: _vm.severChange },
                            model: {
                              value: _vm.paramsData.server_id,
                              callback: function($$v) {
                                _vm.$set(_vm.paramsData, "server_id", $$v)
                              },
                              expression: "paramsData.server_id"
                            }
                          },
                          [
                            _c(
                              "el-checkbox",
                              {
                                on: { change: _vm.selectAll },
                                model: {
                                  value: _vm.checked,
                                  callback: function($$v) {
                                    _vm.checked = $$v
                                  },
                                  expression: "checked"
                                }
                              },
                              [_vm._v("全选")]
                            ),
                            _vm._l(_vm.serverListYJ, function(item) {
                              return _c("el-option", {
                                key: item.serverID,
                                attrs: {
                                  label: item.serverName,
                                  value: item.serverID
                                }
                              })
                            })
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ]
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { round: "" },
                  on: {
                    click: function($event) {
                      return _vm.resetForm("ruleForm")
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "warning", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.clearData()
                    }
                  }
                },
                [_vm._v("重置")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.dataFormSubmit("ruleForm")
                    }
                  }
                },
                [_vm._v("提交")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }